import {
	preventDoubleClick
} from '../global/_doubleClick';

export var orderCancelConfirmation = function(params, returnHTML) {
      function myCallback() {
          $("#orderCancelConfirm").on("click", ()=>{
            $.ajax({
                method: "POST",
                url: "/wcs/resources/store/301/purchaseHistory/orderDetail/cancel?orderId=" + params.orderNum,
                success: function(){
                    $('.cancel-order').hide();
                    $('#cancelOrderSuccess').removeClass('hidden');
                },
                error: function(error){
                	if(error.responseJSON.response.RSVErrorCode === '510'){
                		$('#cancelOrderAlreadyCancelled').removeClass('hidden');
                	} 
                    else if(error.responseJSON.response.RSVErrorCode === '550'){
                		$('#cancelOrderAimsUnavailable').removeClass('hidden');
                	} 
                    else {
                		$('#cancelOrderError').removeClass('hidden');
                	}
                    $('.cancel-order').hide();
                }
            })
        });
      }

      $.ajax({
          url: "/static/html/modals/_cancel-order-modal.html",
          success: function(html) {
              returnHTML(html, myCallback);
              return false;
          }
      });
  };
